<template>
    <div>
        <opportunity-form-modal></opportunity-form-modal>
        <opportunity-context-menu></opportunity-context-menu>
        <opportunity-meeting-form-modal></opportunity-meeting-form-modal>
        <opportunity-meeting-context-menu></opportunity-meeting-context-menu>

        <worksite-form-modal></worksite-form-modal>
        <worksite-context-menu></worksite-context-menu>
        
        <worksite-phase-context-menu></worksite-phase-context-menu>
        <worksite-phase-form-modal></worksite-phase-form-modal>
        <worksite-phase-trustup-io-task-context-menu></worksite-phase-trustup-io-task-context-menu>
        <worksite-phase-trustup-io-task-modal></worksite-phase-trustup-io-task-modal>
        <worksite-phase-trustup-io-task-form-modal></worksite-phase-trustup-io-task-form-modal>

        <worksite-profitability-document-context-menu></worksite-profitability-document-context-menu>
        <worksite-profitability-document-modal></worksite-profitability-document-modal>
        <worksite-profitability-document-form-modal></worksite-profitability-document-form-modal>

        <worksite-file-context-menu></worksite-file-context-menu>
        <worksite-file-modal></worksite-file-modal>
        
        <worksite-file-folder-context-menu></worksite-file-folder-context-menu>
        <worksite-file-folder-form-modal></worksite-file-folder-form-modal>
    </div>
</template>

<script>
    import OpportunityFormModal from './Opportunity/FormModal';
    import OpportunityContextMenu from './Opportunity/ContextMenu';
    import OpportunityMeetingFormModal from './OpportunityMeeting/FormModal';
    import OpportunityMeetingContextMenu from './OpportunityMeeting/ContextMenu';

    import WorksiteFormModal from './Worksite/FormModal';
    import WorksiteContextMenu from './Worksite/ContextMenu';

    import WorksiteProfitabilityDocumentModal from './WorksiteProfitabilityDocument/Modal';
    import WorksiteProfitabilityDocumentFormModal from './WorksiteProfitabilityDocument/FormModal';
    import WorksiteProfitabilityDocumentContextMenu from './WorksiteProfitabilityDocument/ContextMenu';

    import WorksiteFileModal from './WorksiteFile/Modal';
    import WorksiteFileContextMenu from './WorksiteFile/ContextMenu';

    import WorksiteFileFolderContextMenu from './WorksiteFileFolder/ContextMenu';
    import WorksiteFileFolderFormModal from './WorksiteFileFolder/FormModal';

    import WorksitePhaseContextMenu from './WorksitePhase/ContextMenu';
    import WorksitePhaseFormModal from './WorksitePhase/FormModal';

    import WorksitePhaseTrustupIoTaskContextMenu from './WorksitePhaseTrustUpIOTask/ContextMenu';
    import WorksitePhaseTrustupIoTaskModal from './WorksitePhaseTrustUpIOTask/Modal';
    import WorksitePhaseTrustupIoTaskFormModal from './WorksitePhaseTrustUpIOTask/FormModal';
    
    export default {
        components: {
            OpportunityFormModal,
            OpportunityContextMenu,
            OpportunityMeetingFormModal,
            OpportunityMeetingContextMenu,

            WorksiteFormModal,
            WorksiteContextMenu,

            WorksiteProfitabilityDocumentModal,
            WorksiteProfitabilityDocumentFormModal,
            WorksiteProfitabilityDocumentContextMenu,

            WorksiteFileModal,
            WorksiteFileContextMenu,

            WorksiteFileFolderContextMenu,
            WorksiteFileFolderFormModal,

            WorksitePhaseContextMenu,
            WorksitePhaseFormModal,

            WorksitePhaseTrustupIoTaskContextMenu,
            WorksitePhaseTrustupIoTaskModal,
            WorksitePhaseTrustupIoTaskFormModal,
        }
    }
</script>